var _path, _path2, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 158,
    viewBox: "0 0 143 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C5.58172 2 2 5.58172 2 10V126C2 130.418 5.58171 134 9.99999 134H53.975L71.3 156L88.625 134H132.6C137.018 134 140.6 130.418 140.6 126V10C140.6 5.58172 137.018 2 132.6 2H10Z",
    fill: "#F7F0F5",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.975 134L55.5463 132.763C55.167 132.281 54.5879 132 53.975 132V134ZM71.3 156L69.7287 157.237C70.1079 157.719 70.687 158 71.3 158C71.9129 158 72.492 157.719 72.8713 157.237L71.3 156ZM88.625 134V132C88.0121 132 87.433 132.281 87.0537 132.763L88.625 134ZM4 10C4 6.68629 6.68629 4 10 4V0C4.47715 0 0 4.47715 0 10H4ZM4 126V10H0V126H4ZM9.99999 132C6.68629 132 4 129.314 4 126H0C0 131.523 4.47714 136 9.99999 136V132ZM53.975 132H9.99999V136H53.975V132ZM52.4037 135.237L69.7287 157.237L72.8713 154.763L55.5463 132.763L52.4037 135.237ZM72.8713 157.237L90.1963 135.237L87.0537 132.763L69.7287 154.763L72.8713 157.237ZM132.6 132H88.625V136H132.6V132ZM138.6 126C138.6 129.314 135.914 132 132.6 132V136C138.123 136 142.6 131.523 142.6 126H138.6ZM138.6 10V126H142.6V10H138.6ZM132.6 4C135.914 4 138.6 6.68629 138.6 10H142.6C142.6 4.47716 138.123 0 132.6 0V4ZM10 4H132.6V0H10V4Z",
    fill: "#F7F0F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.1176,
    height: 14.2314,
    rx: 2,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 101.238 76.7354)",
    fill: "#F7F0F5",
    fillOpacity: 0.25,
    stroke: "#F7F0F5",
    strokeWidth: 4,
    strokeLinecap: "square"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18.1176,
    height: 14.2314,
    rx: 2,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 78.0068 76.7354)",
    fill: "#F7F0F5",
    fillOpacity: 0.25,
    stroke: "#F7F0F5",
    strokeWidth: 4,
    strokeLinecap: "square"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18.1176,
    height: 14.2314,
    rx: 2,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 54.7754 76.7354)",
    fill: "#F7F0F5",
    fillOpacity: 0.25,
    stroke: "#F7F0F5",
    strokeWidth: 4,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChating);
export default __webpack_public_path__ + "static/media/chating.4bd76fdcaaa2345844998aa40e383a5e.svg";
export { ForwardRef as ReactComponent };